"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormBase;

var _react = _interopRequireDefault(require("react"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _scss = require("@scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function FormBase(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      label = _ref.label,
      error = _ref.error,
      success = _ref.success,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    element: '',
    wrapper: '',
    label: '',
    validator: ''
  } : _ref$classes;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['form-group'], classes['wrapper'])
  }, label ? /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: name,
    className: (0, _scss.cls)(classes['label']),
    dangerouslySetInnerHTML: {
      __html: label
    }
  }) : null, children, error && typeof error === 'string' || success && typeof success === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(error ? _stylesModule["default"]['invalid-feedback'] : _stylesModule["default"]['valid-feedback'], classes['validator'])
  }, /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: error ? error : success ? success : ''
    }
  })) : null);
}